import * as React from 'react';

import Box from '@mui/material/Box';

import AppPage from '@/ui/AppPage/AppPage';
import GradingTable from './GradingTable';

import Permissions from '@/lib/permissions';

const GradingPage = () => (
  <AppPage needPermission={[Permissions.PristupacnostCore]} titlett="pristupacnost:titles.evaluacija_objekata">
    <Box m={0} style={{ height: '100%' }}>
      <GradingTable />
    </Box>
  </AppPage>
);

export default GradingPage;
